/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_SidebarInputs */

const en_tut_sc_sidebar = /** @type {(inputs: Tut_Sc_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide or show the left menu`)
};

const id_tut_sc_sidebar = /** @type {(inputs: Tut_Sc_SidebarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sembunyikan atau tampilkan menu kiri`)
};

/**
* | output |
* | --- |
* | "Hide or show the left menu" |
*
* @param {Tut_Sc_SidebarInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_sidebar = /** @type {((inputs?: Tut_Sc_SidebarInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_SidebarInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_sidebar(inputs)
	return en_tut_sc_sidebar(inputs)
});